import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { selectIsAuth } from '@rpt-ngrx/selectors/session.selector';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private store: Store,
    ) {}

    canActivate() {
        return this.store.select(selectIsAuth).pipe(
            map((isAuthenticated) => {
                if (isAuthenticated) {
                    return true;
                } else {
                    this.router.navigate(['/login']);
                    return false;
                }
            }),
        );
    }
}
